/**
 * Configuration utilities for handling environment-specific settings
 */

/**
 * Get the base path for the application based on environment
 * Development: /aleph/
 * Production: /
 */
export const getBasePath = (): string => {
  // Check if we're in build mode (production)
  const isProduction = import.meta.env.PROD;

  // Allow override via environment variable
  const envBasePath = import.meta.env.VITE_BASE_PATH;

  if (envBasePath !== undefined) {
    // Ensure the path starts and ends with /
    const normalizedPath = envBasePath.startsWith('/') ? envBasePath : `/${envBasePath}`;
    return normalizedPath.endsWith('/') ? normalizedPath : `${normalizedPath}/`;
  }

  // Default behavior: /aleph/ for development, / for production
  return isProduction ? '/' : '/aleph/';
};

/**
 * Words of surrounding book text sent to the AI as context (used by voice
 * in useRTVIClient).
 */
export const AI_CONTEXT_WORD_COUNT = 200;

/**
 * Continuation window for text-chat conversations. When the sheet opens at the
 * current playback position, a prior conversation is offered for continuation
 * if its anchor falls within this asymmetric window around "now". The window
 * leans backward on purpose: a reader chats about what they've just heard, so
 * an anchor well behind the current spot is still "the same passage", while one
 * ahead of it likely belongs to a different moment.
 *
 * This is the single source of truth for grouping — the client owns the
 * decision and the backend no longer re-derives it.
 */
export const CONVERSATION_CONTINUATION_WINDOW_BEHIND_S = 20;
export const CONVERSATION_CONTINUATION_WINDOW_AHEAD_S = 5;

/**
 * How long after a voice session disconnects before the reader refetches the
 * book's conversations for its margin dots. The bot writes per turn and
 * flushes on exit, so the last rows land shortly after the transport closes.
 */
export const VOICE_CONVERSATION_FLUSH_DELAY_MS = 1500;
